export enum MessagesEnum {
  UNABLE_RESENT_OTP = 'Unable to resent OTP',
  UNABLE_VERIFY_OTP = 'Unable to verify OTP',
  OTP_REQUIRED = 'OTP is require',
}
